import React from 'react';
import FlowTerminusLayout from '~/client/components/flow-terminus-layout/flow-terminus-layout';
import type { BootCampShopError as Props } from './boot-camp-shop-error.types';

const BootCampShopError: React.FC<Props> = props => (
  <FlowTerminusLayout {...props} />
);

export default BootCampShopError;
